"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
class PaymentSheet extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'paymentSheet';
        this._setupIntent = initParams.setup_intent;
        this._ephemeralKey = initParams.ephemeral_key;
        this._customer = initParams.customer;
        this._publishableKey = initParams.publishable_key;
    }
    set setupIntent(value) {
        console.error('Do not set objects this way');
    }
    get setupIntent() {
        return this._setupIntent;
    }
    set ephemeralKey(value) {
        console.error('Do not set objects this way');
    }
    get ephemeralKey() {
        return this._ephemeralKey;
    }
    set customer(value) {
        console.error('Do not set objects this way');
    }
    get customer() {
        return this._customer;
    }
    set publishableKey(value) {
        console.error('Do not set objects this way');
    }
    get publishableKey() {
        return this._publishableKey;
    }
}
exports.default = PaymentSheet;
//# sourceMappingURL=paymentSheet.js.map